module.exports = __webpack_public_path__ + "img/HZ-P1012.6c2e8d69.jpg";